import React from 'react';

import styled from 'styled-components';

import CommunityAdminContentCompanySelector from './CommunityAdminContentCompanySelector';
import CommunityAdminContentHoldingSelector from './CommunityAdminContentHoldingSelector';
import CommunityAdminContentMysteryShopping from './CommunityAdminContentMysteryShopping';

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px 30px;
  gap: 42px;
  border-bottom: 1px solid var(--line-gray);
`;

const CompanyColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CommunityCreateContentCompany = () => {
  return (
    <Container>
      <CompanyColumn>
        <CommunityAdminContentCompanySelector />
        <CommunityAdminContentHoldingSelector />
      </CompanyColumn>
      <CommunityAdminContentMysteryShopping />
    </Container>
  );
};

export default CommunityCreateContentCompany;
